import { setCoreApiAuth, setCoreApiBaseUrl } from "@justhome/api-runtime";
import logger, { LoggerOptions } from "./logger";

interface ApiConfig {
  baseUrl?: string;
  useAccessToken: () => string | undefined;
  useHeaders: () => Record<string, string | undefined>;
}

interface PartialCommonConfig {
  api?: Partial<{
    core: Partial<ApiConfig>;
  }>;
  logger?: LoggerOptions;
}

interface CommonConfig {
  api: {
    core: ApiConfig;
  };
}

let config: CommonConfig;

export const setConfig = (value: PartialCommonConfig) => {
  config = {
    api: {
      core: {
        useAccessToken: () => undefined,
        useHeaders: () => ({}),
        ...value.api?.core,
      },
    },
  };

  setCoreApiBaseUrl(config.api.core.baseUrl ?? "http://localhost:5000");
  setCoreApiAuth({
    useAccessToken: () => getConfig().api.core.useAccessToken(),
    useHeaders: () => getConfig().api.core.useHeaders(),
  });

  if (value.logger) {
    logger.init(value.logger);
  }
};

export const getConfig = (): CommonConfig => {
  return config;
};
